import { NavLink } from 'react-router-dom';

interface Tab {
  to: string;
  label: string;
}

const TABS: Tab[] = [
  { to: '/admin/matches', label: 'Mecze' },
  { to: '/admin/users', label: 'Użytkownicy' },
  { to: '/admin/rooms', label: 'Pokoje' },
  { to: '/admin/invitations', label: 'Zaproszenia' },
];

export function AdminTabs() {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        marginBottom: 20,
        borderBottom: '1px solid rgba(15,30,61,.08)',
        padding: '0 36px',
      }}
    >
      {TABS.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          style={({ isActive }) => ({
            padding: '12px 4px',
            marginRight: 10,
            fontSize: 14,
            fontWeight: isActive ? 700 : 500,
            color: isActive ? '#0f1e3d' : '#5b6578',
            borderBottom: isActive ? '2px solid var(--accent)' : '2px solid transparent',
            marginBottom: -1,
            textDecoration: 'none',
          })}
        >
          {t.label}
        </NavLink>
      ))}
    </div>
  );
}
